/**
 * PrivateLayout — thin wrapper around AppShell.
 *
 * Kept as a separate file so every protected route that imports
 * PrivateLayout continues to work without changes. All the layout
 * logic moved into AppShell during the dashboard refresh.
 */

import AppShell from './AppShell'

const PrivateLayout = ({ children }) => {
  return <AppShell>{children}</AppShell>
}

export default PrivateLayout
